import rpcService, { withLocalePathSegment } from "@/base/rpc/rpc-service";
import state from "@/base/state";
import { BOOKID } from "../configs";
import { IDocumentsResponse } from "../types/doc-types";


export const fetchChildren = async (query: {key?: string, edition: string}): Promise<IDocumentsResponse> => {
    return rpcService.getJSON<IDocumentsResponse>(`/${query.edition}/${withLocalePathSegment(query.edition, state.locale)}docs`, {bookId: BOOKID, parentKey: query?.key || ''});
}
